import { useApiClient } from '~/api-client';
import { useQuery } from '@tanstack/react-query';
import { GetFederatedSearchQueriesLinks } from '@mark43/cad-api/dist/resources/FederatedSearchResource';

export function useCadLinkedEntitiesByQueryId(federatedQueryIds?: string[]) {
    const apiClient = useApiClient();

    return useQuery(
        ['cad-entities-fed-search-query', federatedQueryIds],
        async () => {
            if (federatedQueryIds) {
                const { data } = await apiClient.request<GetFederatedSearchQueriesLinks>({
                    method: 'POST',
                    url: 'federated_search/get_federated_search_queries_links',
                    data: {
                        federatedQueryIds,
                    },
                });
                return data?.data?.federatedSearchQueryLinks;
            }
        },
        {
            enabled: !!federatedQueryIds?.length,
        }
    );
}
